import { render, staticRenderFns } from "./SettingsSecurity.vue?vue&type=template&id=8ffe5940"
import script from "./SettingsSecurity.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsSecurity.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports